import { Reveal } from "@/components/Reveal";

const products = [
  {
    id: "tee",
    name: "“FIYA RED” Tee",
    desc: "Inspired by Fiya Red's sound and visual world — blending vintage tour merch, city energy, and the bold attitude behind her music.",
    img: "/assets/merch-tee.png",
  },
  {
    id: "hoodie",
    name: "“Girls Don't Dress for Boys” Hoodie",
    desc: "Inspired by the confidence and independence in Fiya Red's music — a reminder to dress, move, and live for yourself.",
    img: "/assets/merch-hoodie.jpg",
  },
];

export const Merch = () => (
  <section id="merch" data-testid="merch-section" className="py-28 md:py-44 bg-[#FDFBF7]">
    <div className="max-w-[1400px] mx-auto px-6 md:px-12">
      <Reveal className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16 md:mb-24">
        <div>
          <p className="text-[11px] font-semibold uppercase tracking-[0.35em] text-[#2D1A13]/50 mb-6">Merch & Packaging</p>
          <h2 className="font-serif-display font-bold tracking-tighter text-4xl md:text-6xl leading-tight">
            The <span className="italic text-[#FF8E9E]">Drip.</span>
          </h2>
        </div>
        <p className="max-w-sm text-sm font-light leading-relaxed text-[#2D1A13]/60">
          Merch concepts designed in-studio for Fiya Red — fresh off the cone, front and back, seam to seam.
        </p>
      </Reveal>

      <div className="grid md:grid-cols-2 gap-10 md:gap-16">
        {products.map((p, i) => (
          <Reveal key={p.id} delay={i * 0.12}>
            <div data-testid={`merch-card-${p.id}`} className="group">
              <div className="relative overflow-hidden rounded-[28px] aspect-square bg-[#F5EBDC]">
                <img
                  src={p.img}
                  alt={`${p.name} design mockup`}
                  loading="lazy"
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700 ease-[cubic-bezier(0.22,1,0.36,1)]"
                />
                <span className="absolute bottom-5 left-5 rounded-full bg-[#FDFBF7]/90 backdrop-blur px-5 py-2 text-[10px] font-semibold uppercase tracking-[0.22em] text-[#2D1A13]">
                  Front + Back
                </span>
              </div>
              <div className="mt-7">
                <h3 className="font-serif-display font-bold text-2xl md:text-3xl tracking-tight mb-2">{p.name}</h3>
                <p className="text-sm font-light text-[#2D1A13]/65 max-w-md leading-relaxed">{p.desc}</p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
